import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/pages/Home';
import Technology from './components/pages/Technology';
import Footer from './components/Footer';
import Contact from './components/pages/Contact';
import Footer1 from './components/Footer1';

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          
          <Route path="/" element={<Home />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>

        
        <Footer1/>
      </Router>
    </>
  );
}

export default App;
